import * as React from 'react';
import { SVGProps } from 'react';

const Channel = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={14}
    height={14}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.434 12.25a.292.292 0 0 1-.287-.343l.353-1.99H1.514a.292.292 0 0 1-.287-.342l.102-.584a.292.292 0 0 1 .287-.241h2.088l.619-3.5H2.336a.292.292 0 0 1-.287-.342l.102-.583a.292.292 0 0 1 .288-.242h2.088l.371-2.092a.292.292 0 0 1 .287-.241h.575c.181 0 .318.164.287.343l-.354 1.99h3.5l.372-2.092a.292.292 0 0 1 .287-.241h.574c.182 0 .32.164.287.343l-.353 1.99h1.986c.181 0 .319.164.288.342l-.103.584a.292.292 0 0 1-.287.241h-2.088l-.618 3.5h1.986c.181 0 .318.163.287.342l-.102.583a.292.292 0 0 1-.287.242H9.333l-.371 2.092a.292.292 0 0 1-.287.241H8.1a.292.292 0 0 1-.288-.343l.354-1.99h-3.5l-.372 2.092a.292.292 0 0 1-.287.241h-.574Zm2.056-7-.619 3.5h3.5l.618-3.5h-3.5Z"
      fill="#000"
    />
  </svg>
);

export default Channel;
